import {HttpOperacionInforme} from "../../../api/httpOperacionInforme";
import {SistemaTipo} from "../../../../../types/enum/enum";


export const descargarInforme = (
  idOperacion: number
): Promise<any> =>
    HttpOperacionInforme.descargarInforme(idOperacion, SistemaTipo.MinutaMercado);
